import Redactor from '../../../lib/redactor/redactor'
import '../../../lib/redactor//plugins/alignment/alignment.min'
import '../../../lib/redactor/plugins/blockbackground/blockbackground.min'
import '../../../lib/redactor/plugins/blockborder/blockborder.min'
import '../../../lib/redactor/plugins/blockclass/blockclass.min'
import '../../../lib/redactor/plugins/blockcode/blockcode.min'
import '../../../lib/redactor/plugins/blockcolor/blockcolor.min'
import '../../../lib/redactor/plugins/blockfontsize/blockfontsize.min'
import '../../../lib/redactor/plugins/blockid/blockid.min'
import '../../../lib/redactor/plugins/blockspacing/blockspacing.min'
import '../../../lib/redactor/plugins/clips/clips.min'
import '../../../lib/redactor/plugins/counter/counter.min'
import '../../../lib/redactor/plugins/definedlinks/definedlinks.min'
import '../../../lib/redactor/plugins/email/email.min'
import '../../../lib/redactor/plugins/emoji/emoji.min'
// import '../../../lib/redactor/plugins/filelink/filelink.min'
import '../../../lib/redactor/plugins/fontcolor/fontcolor.min'
// import '../../../lib/redactor/plugins/fontfamily/fontfamily.min'
import '../../../lib/redactor/plugins/fontsize/fontsize.min'
import '../../../lib/redactor/plugins/fullscreen/fullscreen.min'
import '../../../lib/redactor/plugins/icons/icons.min'
import '../../../lib/redactor/plugins/imageresize/imageresize.min'
// import '../../../lib/redactor/plugins/math/math.min'
// import '../../../lib/redactor/plugins/mention/mention.min'
import '../../../lib/redactor/plugins/mergetag/mergetag.min'
// import '../../../lib/redactor/plugins/print/print.min'
import '../../../lib/redactor/plugins/snippets/snippets.min'
import '../../../lib/redactor/plugins/specialchars/specialchars.min'
import '../../../lib/redactor/plugins/templates/templates.min'
// import '../../../lib/redactor/plugins/textdirection/textdirection.min'
import '../../../lib/redactor/plugins/textexpander/textexpander.min'
// import '../../../lib/redactor/plugins/variable/variable.min'
import '../../../lib/redactor/plugins/mergecell/mergecell.min'

const DEFAULT_PLUGINS = [
  'alignment',
  'blockbackground',
  'blockborder',
  'blockclass',
  'blockcode',
  'blockcolor',
  'blockfontsize',
  'blockid',
  'blockspacing',
  'clips',
  'counter',
  'definedlinks',
  'emoji',
  'fontcolor',
  'fontsize',
  'fullscreen',
  'icons',
  'imageresize',
  'mergetag',
  'specialchars',
  'textexpander',
  'mergecell',
  // 'email',
  // 'filelink',
  // 'fontfamily',
  // 'math',
  // 'mention',
  // 'print',
  // 'snippets',
  // 'templates',
  // 'textdirection',
  // 'variable',
]

const DEFAULT_SETTINGS = {
  plugins: DEFAULT_PLUGINS,
  // blockcode
  control: true,
}

const buildRedactor = (selector, settings = {}) => {
  return Redactor(selector, { ...DEFAULT_SETTINGS, ...settings })
}

export {
  DEFAULT_PLUGINS,
  DEFAULT_SETTINGS,
  buildRedactor,
}
